import { Grid } from "@maxhub/max-ui"

export const GridExample = {
    title: 'Grid',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'gapX',
            label: 'gapX',
            type: 'text',
            tsType: ['string', 'number'],
            default: '30',
        },
        {
            name: 'gapY',
            label: 'gapY',
            type: 'text',
            tsType: ['string', 'number'],
            default: '10',
        },
        {
            name: 'cols',
            label: 'cols',
            type: 'text',
            tsType: 'number',
            default: '3',
        },
        {
            name: 'rows',
            label: 'rows',
            type: 'text',
            tsType: 'number',
            default: '0',
        },
        {
            name: 'display',
            label: 'display',
            type: 'enum',
            tsType: ['"grid"', '"inline-grid"'],
            default: 'grid',
            options: ['grid', 'inline-grid'],
        },
        {
            name: 'align',
            label: 'align',
            type: 'enum',
            tsType: ['"center"', '"baseline"', '"stretch"', '"start"', '"end"'],
            default: 'center',
            options: ['center', 'baseline', 'stretch', 'start', 'end'],
        },
        {
            name: 'justify',
            label: 'justify',
            type: 'enum',
            tsType: ['"center"', '"start"', '"end"', '"space-between"'],
            default: 'center',
            options: ['center', 'start', 'end', 'space-between'],
        },
        {
            name: 'gap',
            label: 'gap',
            type: 'text',
            tsType: ['string', 'number'],
            default: '10',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
    ],

    Preview({ props }){
        const { gapX, gapY, gap, cols, rows, display, align, justify, ...rest } = props

        const boxStyle = {
            backgroundColor: 'var(--background-surface-secondary)',
            height: 75,
            width: 75,
        }

        return (
            <Grid
                gap={Number(gap)}
                gapX={Number(gapX)}
                gapY={Number(gapY)}
                cols={Number(cols)}
                rows={Number(rows) || undefined}
                display={display}
                align={align}
                justify={justify}
                {...rest}
            >
                <div style={boxStyle} />
                <div style={boxStyle} />
                <div style={boxStyle} />
                <div style={boxStyle} />
                <div style={boxStyle} />
            </Grid>
        )
    },

    getCode(props){
        const { gap, gapX, gapY, cols, rows, display, align, justify } = props
        const attrs = []

        if (gap !== '10') attrs.push(`gap={${gap}}`)
        if (gapX !== '30') attrs.push(`gapX={${gapX}}`)
        if (gapY !== '10') attrs.push(`gapY={${gapY}}`)
        if (cols !== '3') attrs.push(`cols={${cols}}`)
        if (rows !== '0') attrs.push(`rows={${rows}}`)
        if (display !== 'grid') attrs.push(`display="${display}"`)
        if (align !== 'center') attrs.push(`align="${align}"`)
        if (justify !== 'center') attrs.push(`justify="${justify}"`)

        const attrString = attrs.length > 0 ? '\n  ' + attrs.join('\n  ') + '\n' : ''

        return `<Grid${attrString}>
  <div
    style={{
      backgroundColor: 'var(--background-surface-secondary)',
      height: 75,
      width: 75
    }}
   />
  <div
    style={{
      backgroundColor: 'var(--background-surface-secondary)',
      height: 75,
      width: 75
    }}
   />
  <div
    style={{
      backgroundColor: 'var(--background-surface-secondary)',
      height: 75,
      width: 75
    }}
   />
  <div
    style={{
      backgroundColor: 'var(--background-surface-secondary)',
      height: 75,
      width: 75
    }}
   />
  <div
    style={{
      backgroundColor: 'var(--background-surface-secondary)',
      height: 75,
      width: 75
    }}
   />
  <div
    style={{
      backgroundColor: 'var(--background-surface-secondary)',
      height: 75,
      width: 75
    }}
   />
</Grid>`
    }

}